import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  toggleNavigation,
} from '@xanadu/ui-shared/modules/navigation/actions';

import PopularSports from '../../../components/homepage/PopularSports/PopularSports';


import {
  changeProduct,
} from '@xanadu/ui-shared/modules/application/actions';

const EMPTY_ARRAY = [];

const mapDispatchToProps = {
  toggleNavigation,
  changeProduct
};

function mapStateToProps(state) {
  return {
    product: state.getIn(['application', 'product']),
    tags: state.getIn(['navigation', 'tags'], EMPTY_ARRAY),
    topFive: state.getIn(['navigation', 'topFive'], EMPTY_ARRAY),
    navEventIds: state.getIn(['navigation', 'eventIds'])
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PopularSports));
